import { DELETE, GET, PATCH } from "../config/axios.config";
import { normalizeNotifications } from "./normalizers";

/** The list response carries `unreadCount` alongside the page of rows. */
export const listNotifications = async ({ page = 1, limit = 20 } = {}) => {
  const res = await GET("/notifications", { params: { page, limit } });
  return {
    notifications: normalizeNotifications(res?.data),
    pagination: res?.pagination || { total: 0, page, limit },
    unreadCount: res?.unreadCount ?? 0,
  };
};

export const markNotificationRead = (id) => PATCH(`/notifications/${id}/read`);

export const markAllNotificationsRead = () => PATCH("/notifications/read-all");

export const deleteNotification = (id) => DELETE(`/notifications/${id}`);
